import { Injectable, EventEmitter } from '@angular/core';

export interface ToastOutletOptions {
    type?: 'success-light' | 'alert-light' | 'info-light' | 'warning-light';
    title?: string;
    autoDismiss?: boolean;
    message?: string;
    dismissAfter?: number;
    icon?: 'icon-circle-check-outline-24' | 'icon-error-outline-24';
}

@Injectable()
export class ToastOutletService {
    onCreate = new EventEmitter<ToastOutletOptions>();

    /**
     *
     * @param options
     */
    create(options: ToastOutletOptions) {
        if (!options) {
            return;
        }
        const transformedOptions = { ...options } as any;

        if (options.type) {
            transformedOptions.type = `${options.type}-light`;
        }

        this.onCreate.emit(options);
    }

    /**
     *
     * @param options
     */
    createAlert(options: ToastOutletOptions) {
        this.create({
            ...options,
            type: 'alert-light',
            icon: 'icon-error-outline-24',
        });
    }

    /**
     *
     * @param options
     */
    createSuccess(options: ToastOutletOptions) {
        this.create({
            ...options,
            type: 'success-light',
            icon: 'icon-circle-check-outline-24',
        });
    }

    /**
     *
     * @param options
     */
    createWarning(options: ToastOutletOptions) {
        this.create({
            ...options,
            type: 'warning-light',
            icon: 'icon-error-outline-24',
        });
    }
}
